<div class="content" [style.height.px]="getWindowHeight()">
  <div class="header">
    <div>
      <span translate>MEDIA.CONTEXT_MENU.EDIT_MIX_THRESHOLD</span>
      <rk-icon-button [bordered]="true" [faIcon]="'fa-times'" (click)="onCancel()">
      </rk-icon-button>
    </div>
  </div>
  <div class="body flex flex-col">
    <div class="tracks">
      <div class="previous">
        <span translate>MEDIA.MODAL.TRACK.MIX_POINTS.INTRO</span>
        <rk-track-input-with-suggestions
          [currentValue]="previousTrack$ | async"
          [placeholder]="'MEDIA.SEARCH_BAR.PLACEHOLDER' | translate"
          (submitted)="savePreviousTrack($event)"
          (blurred)="blurPreviousTrackInput()"
        ></rk-track-input-with-suggestions>
      </div>
      <div class="current flex justify-center">
        <img [src]="dataIn.track.cover" alt="cover" />
        <div class="flex flex-col">
          <span class="title">{{ dataIn.track.title }}</span>
          <span class="artist">{{ dataIn.track.artist }}</span>
        </div>
      </div>
      <div class="next">
        <span translate>MEDIA.MODAL.TRACK.MIX_POINTS.EXTRO</span>
        <rk-track-input-with-suggestions
          [currentValue]="nextTrack$ | async"
          [placeholder]="'MEDIA.SEARCH_BAR.PLACEHOLDER' | translate"
          (submitted)="saveNextTrack($event)"
          (blurred)="blurNextTrackInput()"
        ></rk-track-input-with-suggestions>
      </div>
    </div>
    <div *ngIf="!(isLoading$ | async) && formCues; else loading">
      <rk-waveform-ui
        [audioUrl]="trackUrl()"
        [trackDuration]="dataIn.track.timeSeconds"
        [audioStart]="formCues.get('intro').value / 1000"
        [fadeInValue]="formCues.get('fadeIn').value / 1000"
        [mixValue]="formCues.get('mix').value / 1000"
        [fadeOutValue]="formCues.get('fadeOut').value / 1000"
        [audioEnd]="formCues.get('extro').value / 1000"
        [isMixActive]="formCues.get('mix').value !== 0"
        [isFadeInActive]="formCues.get('fadeIn').value !== 0"
        [isFadeOutActive]="formCues.get('fadeOut').value !== 0"
        [waveformUrl]="formCues.get('waveformUrl').value"
        [previousTrack]="previousTrackCues$ | async"
        [nextTrack]="nextTrackCues$ | async"
        (startChanged)="startChanged($event)"
        (fadeInChanged)="fadeInChanged($event)"
        (mixChanged)="mixChanged($event)"
        (fadeOutChanged)="fadeOutChanged($event)"
        (endChanged)="endChanged($event)"
        (isPlaying)="isPlaying($event)"
        (durationChanged)="durationChanged($event)"
      ></rk-waveform-ui>
      <div class="cues flex justify-center">
        <rk-button
          data-cy="calculate"
          [btnStyle]="'link'"
          [label]="calculateLabel"
          [faIcon]="'fa-magic'"
          [iconSize]="'12px'"
          [disabled]="isCalculating$ | async"
          (click)="calculateTrackCues()"
        ></rk-button>
      </div>
      <form *ngIf="formCues" [formGroup]="formCues" novalidate>
        <div class="cues-input flex justify-center">
          <rk-cue-input
            formControlName="intro"
            [label]="'MEDIA.MODAL.TRACK.MIX_POINTS.START' | translate"
            [colorClass]="'inout'"
            [maxValue]="getMaxValueForField('intro')"
            (setValueAtCursor)="setStartAtCursor()"
            (resetValue)="resetStart()"
          ></rk-cue-input>
          <rk-cue-input
            formControlName="fadeIn"
            [label]="'MEDIA.MODAL.TRACK.MIX_POINTS.FADEIN' | translate"
            [colorClass]="'fadein'"
            [minValue]="msToStringValue(formCues.get('intro').value)"
            [maxValue]="getMaxValueForField('fadeIn')"
            (setValueAtCursor)="setFadeInAtCursor()"
            (resetValue)="removeFadeIn()"
          ></rk-cue-input>
          <rk-cue-input
            formControlName="fadeOut"
            [label]="'MEDIA.MODAL.TRACK.MIX_POINTS.FADEOUT' | translate"
            [colorClass]="'fadeout'"
            [minValue]="getMinValueForField('fadeOut')"
            [maxValue]="msToStringValue(formCues.get('extro').value)"
            (setValueAtCursor)="setFadeOutAtCursor()"
            (resetValue)="removeFadeOut()"
          ></rk-cue-input>
          <rk-cue-input
            formControlName="mix"
            [label]="'MEDIA.MODAL.TRACK.MIX_POINTS.MIX' | translate"
            [colorClass]="'mix'"
            [minValue]="getMinValueForField('mix')"
            [maxValue]="msToStringValue(formCues.get('extro').value)"
            (setValueAtCursor)="setMixAtCursor()"
            (resetValue)="removeMix()"
          ></rk-cue-input>
          <rk-cue-input
            formControlName="extro"
            [label]="'MEDIA.MODAL.TRACK.MIX_POINTS.END' | translate"
            [colorClass]="'inout'"
            [minValue]="getMinValueForField('extro')"
            [maxValue]="getMaxValueForField('extro')"
            (setValueAtCursor)="setEndAtCursor()"
            (resetValue)="resetEnd()"
          ></rk-cue-input>
        </div>
        <div class="play-buttons flex justify-center">
          <rk-button
            [btnStyle]="'orange'"
            (click)="playIntro()"
            [label]="'MEDIA.MODAL.TRACK.MIX_POINTS.PLAY_INTRO' | translate"
          ></rk-button>
          <rk-button
            *ngIf="!waveformPlaying; else pause"
            [btnStyle]="'orange'"
            [faIcon]="'fa-play'"
            [iconSize]="'12px'"
            (click)="playOrPause()"
            [label]="'MEDIA.MODAL.TRACK.MIX_POINTS.PLAY' | translate"
          ></rk-button>
          <ng-template #pause>
            <rk-button
              [btnStyle]="'orange'"
              [faIcon]="'fa-pause'"
              [iconSize]="'12px'"
              (click)="playOrPause()"
              [label]="'MEDIA.MODAL.TRACK.MIX_POINTS.PAUSE' | translate"
            ></rk-button>
          </ng-template>
          <rk-button
            [btnStyle]="'orange'"
            (click)="playEnd()"
            [label]="'MEDIA.MODAL.TRACK.MIX_POINTS.PLAY_EXTRO' | translate"
          ></rk-button>
        </div>
      </form>
    </div>
  </div>
  <div class="footer">
    <rk-button
      data-cy="modal-cancel-button"
      *ngIf="!(isSaving$ | async)"
      (click)="onCancel()"
      [btnStyle]="'flat'"
      [label]="'MODAL.DEFAULT.CANCEL' | translate"
    ></rk-button>
    <rk-loader [isLoading]="isSaving$ | async" [size]="25"></rk-loader>
    <rk-hotkeys-help-tooltip [disable]="isSaving$ | async">
      <rk-button
        data-cy="modal-submit-button"
        [disabled]="isSaving$ | async"
        (click)="onSubmit()"
        [label]="'MODAL.DEFAULT.SUBMIT' | translate"
      ></rk-button>
    </rk-hotkeys-help-tooltip>
  </div>
</div>

<ng-template #loading>
  <div [style.height.px]="466" class="flex items-center justify-center">
    <rk-loader [center]="true" [isLoading]="true" [size]="35"></rk-loader>
  </div>
</ng-template>
